import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import SearchIcon from '@mui/icons-material/Search';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import toast from 'react-hot-toast';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import Collapse from '@mui/material/Collapse';

import './seccionRol.scss';
export default function SeccionRol({ rolesSeleccionados, setRolesSeleccionados }) {

  const [rolesDisponibles, setRolesDisponibles] = useState("");
  const [rolesDisponiblesOriginal, setRolesDisponiblesOriginal] = useState("");
  const [rolesNoCompatibles, setRolesNoCompatibles] = useState("");
  const [showFilterInput, setShowFilterInput] = useState(false);
  const [filterInput, setFilterInput] = useState('');

  useEffect(() => {
    getRolesDisponibles();
    getRolesNoCompatibles({
      variables: { "idRol": 0 },
    });
  }, []);

  const QGetRoles = gql`
        query QGetRoles{
            roles
                {
                    success,
                    error,
                    valorEsperado {
                        id,
                        descripcion,
                        idFuncion,
                        idTipoProfesional,
                        activo
                    }
                }
        }`;

  const [getRolesDisponibles, { data: dataRoles }] = useLazyQuery(QGetRoles, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataRoles?.roles?.success) return;
    const dataAll = dataRoles.roles.valorEsperado;
    setRolesDisponibles(dataAll);
    setRolesDisponiblesOriginal(dataAll);
  }, [dataRoles]);

  const QGetRolesNoCompatibles = gql`
        query GetRolNoCompatible ($idRol:Int!){
            rolNoCompatible(idRol:$idRol) {
            success,
            error,
            valorEsperado {
                id,
                idRol,
                idRolNoCompatible
            }
            }             
        }`;

  const [getRolesNoCompatibles, { data: dataNC }] = useLazyQuery(QGetRolesNoCompatibles, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataNC?.rolNoCompatible?.success) return;
    setRolesNoCompatibles(dataNC.rolNoCompatible.valorEsperado);
  }, [dataNC]);

  const handleSearch = (e) => {
    if (e?.target?.value != "") {
      if (e?.target?.value.length >= 3) {
        setRolesDisponibles(rolesDisponiblesOriginal.filter((rolesDisponiblesOriginal) => {
          const descripcionBuscar = rolesDisponiblesOriginal.descripcion.toLowerCase();

          const inputBuscar = e?.target?.value.toLowerCase();
          return (
            descripcionBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      getRolesDisponibles();
    }
  };


  // Click sobre fila de la grilla de búsqueda de roles disponibles
  const handleRowClick = (params) => {

    let agregar = true;

    if (rolesSeleccionados != null && rolesSeleccionados.length > 0) {
      // verifico que no haya sido seleccionado anteriormente
      const nodo = rolesSeleccionados.filter((item) => item.id === params.row.id);
      if (nodo.length > 0) {
        agregar = false;
        toast.error("El Rol ya se encuentra seleccionado");
      }

      // verifico la compatibilidad con los demás roles seleccionados
      rolesSeleccionados?.map((rol) => {
        if (agregar) {
          const existe = rolesNoCompatibles.filter((nc) => nc.idRol === rol.id && nc.idRolNoCompatible === parseInt(params.row.id, 10));
          if (existe.length > 0) {
            agregar = false;
            toast.error("El Rol " + params.row.descripcion + " no es compatible con el Rol " + rol.descripcion);
          }
        }
      });
    }

    if (agregar) {
      setRolesSeleccionados([...rolesSeleccionados, params.row]);
    }
  };

  const borrarRolSeleccionado = (rol) => {
    setRolesSeleccionados((rolesSeleccionados) => rolesSeleccionados.filter((item) => item.id !== rol.id));
  };

  const roleColumns = generateColumnsDefaultConfiguration([
    { field: 'id', headerName: 'Id', flex: 0.08 },
    { field: 'descripcion', headerName: 'Descripción', flex: 0.4 },
    {
      field: 'action',
      headerName: '',
      renderCell: (params) => {
        return (
          <div className='add-role' onClick={() => handleRowClick(params)} aria-hidden='true'>
            AGREGAR
          </div>);

      }
    }]
  );

  const selectedRoleColumns = generateColumnsDefaultConfiguration([
    { field: 'id', headerName: 'Id', flex: 0.08 },
    { field: 'descripcion', headerName: 'Descripción' },
    {
      field: 'action',
      headerName: '',
      renderCell: (params) => {
        return (
          <DeleteOutlinedIcon
            sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
            onClick={() => borrarRolSeleccionado(params.row)}
            titleAccess='Borrar rol seleccionado' />);


      }
    }]
  );

  return (
    <div className='seccion-rol-container'>
      <Grid container columns={{ xs: 1, md: 2 }} spacing={3}>
        <Grid size={{ xs: 1 }}>
          <div className='seccion-rol-table'>
            <div className='seccion-rol-table-header'>
              <h4 className='seccion-rol-title'>Roles disponibles</h4>
              <div className='seccion-rol-table-header'>
                <Collapse in={showFilterInput} orientation='horizontal'>
                  <TextInput
                    label='Filtrar'
                    onChange={(e) => {
                      setFilterInput(e.target.value);
                      handleSearch(e);
                    }}
                    onClearButtonClick={() => {
                      setFilterInput('');
                      handleSearch({ target: { value: '' } });
                    }}
                    value={filterInput}
                    onBlur={(e) => {
                      if (e.target.value === '') {
                        setShowFilterInput(false);
                      }
                    }} />

                </Collapse>
                <Collapse in={!showFilterInput} orientation='horizontal'>
                  <SearchIcon
                    className='search-icon'
                    onClick={() => {
                      setShowFilterInput(true);
                    }} />

                </Collapse>
              </div>
            </div>
            <DataGridGenerico
              columns={roleColumns}
              rows={rolesDisponibles}
              toolbar={false}
              rowsPerPage={[10]} />

          </div>
        </Grid>
        <Grid size={{ xs: 1 }}>
          <div className='seccion-rol-table'>
            <h4 className='seccion-rol-title'>Roles seleccionados</h4>
            <DataGridGenerico
              columns={selectedRoleColumns}
              rows={rolesSeleccionados}
              toolbar={false}
              hideFooter={true} />

          </div>
        </Grid>
      </Grid>
    </div>);

};